<template>
    <div class="footer">
        <section class="page-footer">
            <div class="page-module" style="overflow: inherit">
                <div class="footer-top">
                    <div class="about-me">
                        <!--<p class="logo">关于资鲸</p>-->
                        <img class="logo" :src="footerLogo" alt="" style="margin-bottom: 15px">
                        <p style="font-size: 14px;">鲸融网是全维度企业成长服务平台，专注于创业创新、商业管理与资本运营方向，以活动、内容、知识、数据、工具及资源等赋能企业成长。</p>
                        <p style="font-size: 14px;">鲸融的使命：让资本赋能企业成长</p>
                        <p style="font-size: 14px;">鲸融的理念：互助成长、价值共享</p>
                    </div>
                    <div class="footer-nav">
                        <p class="title">快速导航</p>
                        <div style="display: flex;">
                            <ul>
                                <li v-if="!isZJ178Domain"><a href="https://www.capwhale.com/index/aboutMe.html" target="_blank">关于我们</a></li>
                                <li v-else><a href="http://www.zj178.com/index/aboutMe.html" target="_blank">关于我们</a></li>
                                <li v-if="!isZJ178Domain"><a href="https://www.capwhale.com/index/swhz.html" target="_blank">商务合作</a></li>
                                <li v-else><a href="http://www.zj178.com/index/swhz.html" target="_blank">商务合作</a></li>
                                <li><a @click="clickEvent('baoGao')">寻求报道</a></li>
                                <li><a @click="clickEvent('touGao')">我要投稿</a></li>
                                <li v-if="!isZJ178Domain"><a target="_block" href="https://www.capwhale.com/index/courseComplaint">侵权投诉</a></li>
                                <li v-else><a target="_block" href="http://www.zj178.com/index/courseComplaint">侵权投诉</a></li>
                            </ul>
                            <ul>
                                <li><a @click="clickEvent('ke')">在线课堂</a></li>
                                <li><a @click="clickEvent('report')">精品投研</a></li>
                                <li><a @click="clickEvent('hr')">资本人才</a></li>
                                <li><a @click="clickEvent('live')">精品直播</a></li>
                            </ul>
                        </div>
                        <!--<ul>-->
                            <!--<li><a href="https://shimo.im/docs/74QkSYDxhTgpPliz" target="_blank">关于我们</a></li>-->
                            <!--<li><a href="http://hd.capwhale.com" target="_blank">鲸活动</a></li> -->
                            <!--<li><a href="http://live.capwhale.com" target="_blank">活动直播</a></li>-->
                        <!--</ul>-->
                    </div>
                    <div class="qrcode">
                        <p class="title">媒体矩阵</p>
                        <div class="content">
                            <ul>
                                <li>
                                    <div class="title"><p>订阅号</p></div>
                                    <div class="popu-qr">
                                        <img src="https://img.capwhale.com/wemedia/36bb8dc44187427984e493773be7cdbd.jpg" alt="订阅号">
                                        <p>订阅号</p> <p>（ID：hiyouib）</p>
                                    </div>
                                </li>
                                <li>
                                    <div class="title"><p>服务号</p></div>
                                    <div class="popu-qr">
                                        <img src="https://img.capwhale.com/wemedia/be931c4a40074d8fbeabe9e3d3dab425.jpg" alt="服务号">
                                        <p>服务号</p> <p>（ID：Capwhale）</p>
                                    </div>
                                </li>
                                <li>
                                    <!--<a href="http://www.capwhale.com/index/matrix.html"><div class="title"><p>媒体联盟</p></div></a>-->
                                    <a @click="clickEvent('mei')"><div class="title"><p>媒体联盟</p></div></a>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="qrcode lxwm">
                        <p class="title">联系我们</p>
                        <div class="content">
                            <p>鲸小二</p>
                            <a href="tel:">0755-86393160</a>
                            <a href="mailto:info@capwhale.com?subject=邮件标题&amp;body=邮件内容">info@capwhale.com</a>
                            <!--<a href="mailto:wanglp@capwhale.com?subject=邮件标题&amp;body=邮件内容">wanglp@capwhale.com</a>-->
                        </div>
                    </div>
                    <div class="footer-friend-herf">
                        <div>
                            <p class="logo">友情链接</p>
                            <!-- <a href="123456" target="_blank">12366666</a>
                            <a href="http://hd.capwhale.com/" target="_blank">鲸活动</a>
                            <a href="11111" target="_blank">12222</a>
                            <a href="ggg" target="_blank">ddd</a>
                            <a href="1234567890" target="_blank">ndsh</a>  -->
                            <!--<template v-if="this.mktype">-->
                                <!--<a style="font-size: 14px;" v-for="(item, index) in hdHrefData" :key="index" :href="item.href" target="_blank">{{item.name}}</a>-->
                            <!--</template>-->
                            <template>
                                <a  style="font-size: 14px;" v-for="(item, index) in friendHrefData" :key="index" :href="item.href" target="_blank">{{item.name}}</a>
                            </template>
                        </div>
                    </div>
                </div>
                <div class="footer-bottom">
                    <div class="center">
                        <!--<span class="logo"><img src="http://www.capwhale.com/static/zixun_v2/new_images/common/logo.png" alt="logo"></span> -->
                        <span class="content" v-if="!isZJ178Domain">
                            <p>
                                <a href="https://www.capwhale.com/index/disclaimer.html">免责声明</a><a href="https://www.capwhale.com/sitemap.xml">网站地图</a>
                                <el-popover  placement="top" width="550" trigger="hover">
                                    <img src="//img.capwhale.com/zz/yyzz-szzj.jpg" style="width: 550px;height: auto;max-height: 500px;" />
                                    <span slot="reference" class="certificate-name">© 2017-2025 鲸融网 版权所有</span>
                                </el-popover>
                                <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-left: 10px;">{{gICPBNNo}}</a>
                                <a :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${recordcode}`" target="_blank">{{gGNBNNo}}</a>
                            </p>
                        </span>
                        <span class="content" v-else>
                            <p>
                                <a href="http://www.zj178.com/index/disclaimer.html">免责声明</a>
                                <a href="http://www.zj178.com/sitemap.xml">网站地图</a>
                                <el-popover  placement="top" width="550" trigger="hover">
                                    <img src="//img.capwhale.com/zz/yyzz-szzj.jpg" style="width: 550px;height: auto;max-height: 500px;" />
                                    <span slot="reference" class="certificate-name">© 2017-2025 鲸融网 版权所有</span>
                                </el-popover>
                                <a href="https://beian.miit.gov.cn/" target="_blank" style="margin-left: 10px;">{{gICPBNNo}}</a>
                                <a :href="`http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=${recordcode}`" target="_blank">{{gGNBNNo}}</a>
                            </p>
                        </span>
                    </div>
                    <div class="center" style="margin-top: 10px;display: flex;justify-content: center;">
                        <div style="margin-right: 10px">
                            <el-popover  placement="top" width="550" trigger="hover">
                                <img src="//img.capwhale.com/zz/cbw-szzj.jpg" style="width: 550px;height: auto;max-height: 500px;" />
                                <span slot="reference" class="certificate-name">出版物许可证：深零字第C1422号</span>
                            </el-popover>
                        </div>
                        <div style="margin-right: 10px">
                            <el-popover  placement="top" width="550" trigger="hover">
                                <img src="//img.capwhale.com/zz/gbds-szzj.jpg" style="width: 550px;height: auto;max-height: 500px;" />
                                <span slot="reference" class="certificate-name">广播电视节目许可证：（粤）字第06283号</span>
                            </el-popover>
                        </div>
                        <div style="margin-right: 10px">
                            <el-popover  placement="top" width="550" trigger="hover">
                                <img src="//img.capwhale.com/zz/icp-szzj.jpg" style="width: 550px;height: auto;max-height: 500px;" />
                                <span slot="reference" class="certificate-name">ICP证：粤B2-20231017</span>
                            </el-popover>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
export default {
    name: 'pageFooter',
    props:['mktype'],
    data() {
        return {
            footerLogo:require('@/common/images/header/new_logo2.png'),
            friendHrefData: [
                {name:'百度', href: 'http://baidu.com'},
                {name:'凤凰网', href: 'http://www.ifeng.com/'},
                {name:'雪球', href: 'https://xueqiu.com/u/8472616478'},
                {name:'今日头条', href: 'https://www.toutiao.com/c/user/token/MS4wLjABAAAAP8ZB-cMkkECa3-N0HYxOhvKR5v2nbYQ3_3ahgEU2RIo/#mid=1559999917498369'},
                {name:'上证指数', href: 'http://quote.eastmoney.com/zs000001.html'},
                {name:'港交所披露易', href: 'https://www.hkexnews.hk/index_c.htm'},
                {name:'中国上市公司披露', href: 'http://www.cninfo.com.cn/new/index'},
                {name:'百度指数行业排行榜', href: 'http://index.baidu.com/v2/rank/index.html?#/industryrank'},
                {name:'企查查', href: 'https://www.qcc.com/'},
                {name:'研究报告', href: 'https://report.capwhale.com/'},
                {name:'股权激励咨询', href: 'http://www.hiyouib.com/page/equity_incentive.html'},
                {name:'董秘研修班', href: 'http://www.hiyouedu.com/page/personnel_training.html'},
                // {name:'中国大百科全书', href: 'http://e.bkzx.cn/home/home.cbs'},
                // {name:'CNKI', href: 'https://www.cnki.net/'},
                // {name:'超星图书馆', href: 'http://www.chaoxing.com/'},
                // {name:'中山大学医学图书馆', href: 'http://202.116.65.75/web/NorthCampus/index'},
                // {name:'中国社会科学引文索引', href: 'http://cssci.nju.edu.cn/login_u.html'},
                // {name:'中国研究服务中心', href: 'http://www.usc.cuhk.edu.hk/Chs/Default.aspx'},
                // {name:'国家科技图书文献中心', href: 'https://www.nstl.gov.cn/'},
                // {name:'谷歌专利搜索', href: 'https://www.google.com/?tbm=pts&gws_rd=ssl'},
                // {name:'自然科学指数', href: 'https://www.natureindex.com/supplements/nature-index-2017-china/inter-city-collaboration'},
                // {name:'学术趋势', href: 'http://trend.cnki.net/TrendSearch/index.htm'}
            ],
            // hdHrefData:[
            //     {name:'资鲸', href: 'http://www.capwhale.com/'},
            //     {name:'报告下载', href: 'http://report.capwhale.com'},
            //     {name:'在线课堂', href: 'http://ke.capwhale.com'},
            //     {name:'人才服务', href: 'http://hr.capwhale.com'},
            //     {name:'百度', href: 'https://www.baidu.com/'},
            //     {name:'凤凰网', href: 'www.ifeng.com'},
            // ]
            gICPBNNo:"粤ICP备17145857号",//ICP备案号
            gGNBNNo:"粤公网安备44030502003760号",//公安备案号
            recordcode:"44030502003760",
            isZJ178Domain:false,//是否是资鲸178域名，需要屏蔽直播和资讯
            domainName:'capwhale.com',
            httpName:"https",
        }
    },
    mounted() {
        let hostname=location.hostname;
        if(hostname.indexOf("zj178.com")>=0){
            this.gICPBNNo="蜀ICP备2020035836号"
            this.gGNBNNo="川公网安备51019002003414号"
            this.recordcode="51019002003414"
            this.isZJ178Domain=true
            this.domainName='zj178.com'
            this.httpName="http"
        }
    },
    methods: {
        clickEvent(val){
            let url=''
            switch (val) {
                case 'ke':
                    // window.open(`${this.domainlist.url_course}?token=${this.user.loginToken}`)
                    url=this.domainlist.url_course
                    if(this.isZJ178Domain){
                        url=url.replace(/capwhale.com/,this.domainName)
                    }
                    window.location.href = url+`?token=${this.user.loginToken}`
                    break
                case 'report':
                    url=this.domainlist.url_report
                    if(this.isZJ178Domain){
                        url=url.replace(/capwhale.com/,this.domainName)
                    }
                    window.location.href =url+`?token=${this.user.loginToken}`
                    break
                case 'hr':
                    url=this.domainlist.url_hr
                    if(this.isZJ178Domain){
                        url=url.replace(/capwhale.com/,this.domainName)
                    }
                    window.location.href = url+`?token=${this.user.loginToken}`
                    break
                case 'live':
                    url=this.domainlist.url_live
                    if(this.isZJ178Domain){
                        url=url.replace(/capwhale.com/,this.domainName)
                    }
                    window.location.href = url+`?token=${this.user.loginToken}`
                    break
                case 'mei':
                    if(!this.isZJ178Domain){
                        window.location.href = `https://www.capwhale.com/index/matrix.html?token=${this.user.loginToken}`
                    }
                    else{
                        window.location.href = `https://www.zj178.com/index/matrix.html?token=${this.user.loginToken}`
                    }
                    break
                case 'baoGao':
                    this.$alert('如有需要报导需求，请把详细内容发送到邮箱 news@capwahle.com,一经录用会有专人和您联系', '信息', {
                        confirmButtonText: '确定',
                    });
                    break
                case 'touGao':
                    this.$alert('如有投稿需求，请把文章发送到邮箱 news@capwahle.com,一经录用会有专人和您联系', '信息', {
                        confirmButtonText: '确定',
                    });
                    break
            }
        }
    },
    watch: {},
    filters: {},
    computed: {
        ...mapGetters([
            'user',
            'domainlist',
        ])
    },
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .footer-top .title{
        border: none!important;
        padding-bottom: 15px!important;
    }
    .page-module {
        margin: auto;
        padding: 0 10px;
        box-sizing: border-box;
        max-width: 1200px;
        min-width: 1200px;
        overflow: hidden;
    }
    .page-footer {
        clear: both;
        position: relative;
        z-index: 3;
        // margin-top: 40px;
        margin-top: 0;
        padding: 20px 0 20px 0;
        min-width: 1200px;
        color: #fff;
        font-size: 14px;
        border-top: solid 4px #4a90e2;
        background: #283746;

        &:hover {
            z-index: 5;
        }

        .page-module {
            overflow: inherit;
        }

        p,
        a {
            color: #fff;
            font-size: 14px;
        }
        p {
            &.logo {
                font-size: 18px;
                font-weight: bold;
            }
        }
        .title {
            margin-bottom: 10px;
            font-size: 20px;
            font-weight: 800;
        }

        .footer-top {
            padding-bottom: 20px;
            width: 100%;
            height: 270px;
            border-bottom: solid 1px #fff;
        }

        .footer-top {
            div {
                float: left;
            }
        }

        .about-me {
            width: 475px;
            line-height: 32px;
            .logo {
                width: 100px;
                height: 27px;
            }
        }

        .footer-nav {
            margin-left: 55px;
            width: 170px;

            ul {
                overflow: hidden;
                li {
                    display: inline-block;
                    float: left;
                    width: calc(100%);
                    margin-bottom: 16px;
                    line-height: 14px;
                    cursor: pointer;
                }
            }
        }
        .qrcode {
            margin-left: 55px;
            width: 160px;
            &.lxwm {
                a {
                    display: inline-block;
                    margin-top: 20px;
                    color: #4a90e2;
                }
            }
        }

        .footer-bottom {
            margin: auto;
            margin-top: 10px;
            overflow: hidden;
            .center {
                text-align: center;
            }
            .logo,
            .content {
                display: inline-block;
            }
            .content {
                text-align: left;
                a {
                    display: inline-block;
                    margin-right: 10px;
                }
                p {
                    margin-top: 10px
                }

            }
            ul {
                margin-bottom: 10px;
                width: 100%;
                overflow: hidden;
            }

            .logo {
                img {
                    margin-right: 10px;
                    width: 280px;
                    height: 40px;
                }
            }
            .certificate-name {
                cursor: pointer;
                &:hover {
                    color: #4a90e2;
                }
            }

        }

        .qrcode {
            ul {
                margin-left: -20px;
                margin-top: -20px;
                li {
                    float: left;
                    position: relative;
                    margin-left: 20px;
                    margin-top: 10px;
                    width: 160px;
                    height: 40px;
                    cursor: pointer;
                    background: rgba(255,255,255,.2);

                    &:hover {
                        background: rgba(255,255,255,.5);
                        .popu-qr {
                            display: block;
                        }
                    }

                    .title {
                        width: 100%;
                        padding: 10px 15px;
                        box-sizing: border-box;

                        p {
                            width: 100%;
                            font-size: 15px;
                            font-weight: normal;
                            line-height: 20px;
                            text-align: center;
                        }
                        img {
                            float: left;
                        }
                    }
                }
            }
            &.lxwm {
                margin-left: 100px;
            }

            .popu-qr {
                display: none;
                position: absolute;
                margin: auto;
                left: 175px;
                right: 0;
                top: -65px;
                width: 140px;
                height: 174px;
                border-radius: 8px;
                border: solid 1px #ccc;
                background: rgba(243,242,258,.9);
                z-index: 999;

                &:before {
                    content: "";
                    display: inline-block;
                    position: absolute;
                    margin: auto;
                    left: -10px;
                    bottom: 0;
                    top: 0;
                    width: 0;
                    height: 0;
                    border-style: solid;
                    border-width: 10px;
                    border-color: #f3f8fc #f3f8fc transparent transparent;
                    transform: rotate(-136deg);
                    -webkit-box-shadow: 1px -1px 1px rgba(0,0,0,.2);
                    -moz-box-shadow: 1px -1px 1px rgba(0,0,0,.2);
                    box-shadow: 1px -1px 1px rgba(0,0,0,.2);
                }
                img {
                    display: block;
                    margin: auto;
                    margin-top: 20px;
                    border: solid 4px #ccc;
                }
                p {
                    color: #666;
                    font-size: 15px;
                    text-align: center;
                }

            }
        }

        .footer-friend-herf {
            display: block;
            width: 100%;
            float: left;
            margin-right: 30px;
            font-size: 16px;
            line-height: 30px;

            p {
                font-size: 18px;
            }
            div {
                // height: 200px;
                margin-top: 21px;
                a {
                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            a {
                float: left;
                margin-right: 30px;
                font-size: 16px;
                line-height: 30px;
            }

        }

    }
    .el-message-box{
        border: none!important;
        border-radius: 0!important;
        width: 360px!important;
        .el-message-box__header{
            background: #4476A7;
            .el-message-box__title{
                color: #fff;
                font-size: 16px;
            }
        }
        .el-message-box__content{
            border-bottom: 1px solid #E9E7E7;
            .el-message-box__message p{
                font-size: 16px;
                color: #333;
                line-height: 26px;
                padding: 10px 2px;
            }
        }
        .el-message-box__headerbtn .el-message-box__close{
            display: none;
        }
        .el-message-box__btns{
            .el-button--primary{
                background: #fff;
                border-color: #E9E7E7;
                color: #333;
                font-size: 16px;
            }
            .el-button--small{
                padding: 6px 15px;
            }
        }
    }
</style>